import { KnockoutRound } from '../types';

export const ROUND_LABELS: Record<KnockoutRound, string> = {
  'round-of-32': 'Round of 32',
  'round-of-16': 'Round of 16',
  'quarter-finals': 'Quarter-Finals',
  'semi-finals': 'Semi-Finals',
  'final': 'Final',
  'consolation-semi-finals': 'Consolation Semi-Finals',
  'third-place': 'Third Place',
  'fifth-place': 'Fifth Place',
  'seventh-place': 'Seventh Place',
};

// Bracket progression order, used to sort match breakdowns in playing order.
export const KNOCKOUT_ROUND_ORDER: KnockoutRound[] = [
  'round-of-32',
  'round-of-16',
  'quarter-finals',
  'consolation-semi-finals',
  'semi-finals',
  'seventh-place',
  'fifth-place',
  'third-place',
  'final',
];

export function getRoundLabel(round: KnockoutRound | string): string {
  return ROUND_LABELS[round as KnockoutRound] || round;
}

export function getEliminationLabel(round: KnockoutRound | string): string {
  return `Eliminated in ${getRoundLabel(round)}`;
}
